module.exports = __webpack_public_path__ + "img/expert.590fc43a.png";